import React from 'react';
import { Zap, Brain, Shield, BarChart3, Settings, Clock } from 'lucide-react';
import { type FeaturesContent } from '../lib/variants';

interface FeaturesProps {
  content: FeaturesContent;
}

const icons = [
  <Zap className="h-6 w-6" key="zap" />,
  <Brain className="h-6 w-6" key="brain" />,
  <Shield className="h-6 w-6" key="shield" />,
  <BarChart3 className="h-6 w-6" key="bar" />,
  <Settings className="h-6 w-6" key="settings" />,
  <Clock className="h-6 w-6" key="clock" />,
];

const Features: React.FC<FeaturesProps> = ({ content }) => {
  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-4">
            {content.headline}
          </h2>
          <p className="text-xl text-gray-600">
            {content.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md hover:border-cyan-200 transition duration-300">
              <div className="w-12 h-12 bg-cyan-50 text-cyan-600 rounded-xl flex items-center justify-center mb-6">
                {icons[index]}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
